import React, { Component } from 'react'
import Table from '@common/Table'
import store from '../../../store'
import columns from './column'
import { observer } from 'mobx-react'
import style from './index.module.less'
import { DragSource, DropTarget } from 'react-dnd'
import SelectionTabel from './SelectionTabel'

class BodyRow extends Component {
  render() {
    const {
      isOver,
      connectDragSource,
      connectDropTarget,
      moveRow,
      ...restProps
    } = this.props

    return connectDragSource(
      connectDropTarget(
        <tr
          {...restProps}
          className={isOver ? style.dropOverUpward : ''}
          style={{ cursor: 'move' }}
        />
      )
    )
  }
}

const rowSource = {
  beginDrag(props) {
    return {
      index: props.index
    }
  }
}

const rowTarget = {
  hover(props, monitor) {
    const dragIndex = monitor.getItem().index
    const hoverIndex = props.index
    if (dragIndex === hoverIndex) {
      return
    }
    props.moveRow(dragIndex, hoverIndex)
    monitor.getItem().index = hoverIndex
  }
}

const DragableBodyRow = DropTarget('row', rowTarget, (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver()
}))(
  DragSource('row', rowSource, connect => ({
    connectDragSource: connect.dragSource()
  }))(BodyRow)
)

@observer
export default class extends Component {
  moveRow = (record, index) => ({
    index,
    moveRow: store.moveRow
  })

  render() {
    const { merchant_category_id, key, $getList } = store

    if (store.title_search && !store.$list.length) {
      return (
        <div className={style.noData}>
          <p>
            未找到于「{store.title_search}」相关的结果，可以搜索其他内容或<span
              onClick={() => store.onTitleChange('')}
            >
              清空搜索结果
            </span>
          </p>
        </div>
      )
    }
    if (store.isSort) {
      return (
        <Table
          store={store}
          columns={columns()}
          pagination={false}
          components={{
            body: {
              row: store.$list ? DragableBodyRow : null
            }
          }}
          onRow={store.isSort ? this.moveRow : () => {}}
        />
      )
    } else {
      return (
        <SelectionTabel
          key={'' + merchant_category_id + key}
          tabKey={key}
          getList={$getList}
        />
      )
    }
  }
}
